<template>
  <div>
    <el-dialog title="Đăng ký chữ ký số IntrustCA" :visible.sync="isOpen" width="800px" :before-close="handleClose"
      :close-on-click-modal="false">
      <div v-loading="isLoading || isLoadingData">
        <el-form :model="form" :rules="rules" ref="registerForm" label-position="top" label-width="auto">
          <!-- Certificate Type Display -->
          <div class="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <div class="text-sm">
              <strong>Loại chữ ký số:</strong>
              {{ certType === 'personal' ? 'Cá nhân' : 'Cá nhân thuộc tổ chức' }}
            </div>
          </div>

          <!-- Common Fields -->
          <el-form-item label="Họ tên khách hàng" prop="name_KH">
            <el-input v-model="form.name_KH" placeholder="VD: Nguyễn Văn A"></el-input>
          </el-form-item>

          <el-form-item label="Số điện thoại" prop="telephoneNumber_KH">
            <el-input v-model="form.telephoneNumber_KH" placeholder="VD: 0944670695"></el-input>
          </el-form-item>

          <el-form-item label="Email" prop="email_KH">
            <el-input v-model="form.email_KH" placeholder="VD: email@example.com"></el-input>
          </el-form-item>

          <el-form-item label="Vị trí cá nhân" prop="personal_position_customer">
            <el-input v-model="form.personal_position_customer" placeholder="VD: Nhân Viên, Quản lý..."></el-input>
          </el-form-item>

          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="Tỉnh/Thành phố" prop="province_code">
                <el-select v-model="form.province_code" placeholder="Chọn tỉnh/thành phố" filterable class="w-100"
                  @change="handleProvinceChange">
                  <el-option v-for="province in provinces" :key="province.code" :label="province.name"
                    :value="province.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="Địa chỉ" prop="address">
                <el-input v-model="form.address" type="textarea" rows="2"
                  placeholder="VD: Thanh Xuân, Hà Nội"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- Identity Document Fields -->
          <el-divider class="my-4"><span class="text-sm">Giấy tờ chứng thực danh tính</span></el-divider>

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="Loại giấy tờ" prop="type_paper_code">
                <el-select v-model="form.type_paper_code" placeholder="Chọn loại giấy tờ" class="w-100">
                  <el-option label="CCCD (Căn cước công dân)" value="CCCD"></el-option>
                  <el-option label="HC (Hộ chiếu)" value="HC"></el-option>
                  <el-option label="CMND (Chứng minh nhân dân)" value="CMND"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Số giấy tờ nhận dạng" prop="individual_identifier_code">
                <el-input v-model="form.individual_identifier_code" placeholder="VD: 031200001649"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- Organization Fields (if applicable) -->
          <template v-if="certType === 'organization'">
            <el-divider><span class="text-sm">Thông tin tổ chức</span></el-divider>

            <el-form-item label="Tên tổ chức" prop="organization_name">
              <el-input v-model="form.organization_name" placeholder="VD: HODO test"></el-input>
            </el-form-item>

            <el-form-item label="Mã số thuế" prop="org_tax_number">
              <el-input v-model="form.org_tax_number" placeholder="VD: 0109377692"></el-input>
            </el-form-item>

            <el-form-item label="Phòng/Bộ phận" prop="department">
              <el-input v-model="form.department" placeholder="VD: CN, IT, HR..."></el-input>
            </el-form-item>

            <el-form-item label="Vị trí trong tổ chức" prop="representative_position_personal">
              <el-input v-model="form.representative_position_personal"
                placeholder="VD: TP (Trưởng Phòng), GĐ (Giám đốc)..."></el-input>
            </el-form-item>
          </template>

          <!-- Contact & Verification -->
          <el-divider><span class="text-sm">Thông tin liên hệ & xác thực</span></el-divider>

          <div class="flex justify-end mb-2">
            <el-button type="text" size="mini" @click="useApplicantAsContact">Dùng thông tin người đăng ký</el-button>
          </div>

          <el-form-item label="Người liên hệ (hợp pháp)" prop="personal_name">
            <el-input v-model="form.personal_name" placeholder="Tên người liên hệ chính thức"></el-input>
          </el-form-item>

          <el-form-item label="Số điện thoại liên hệ" prop="mobile_legal">
            <el-input v-model="form.mobile_legal" placeholder="VD: 0944670695"></el-input>
          </el-form-item>

          <el-form-item label="Email liên hệ" prop="email_legal">
            <el-input v-model="form.email_legal" placeholder="VD: contact@example.com"></el-input>
          </el-form-item>

          <!-- Certificate Settings -->
          <el-divider class="my-4"><span class="text-sm">Cấu hình chứ ký</span></el-divider>

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="Loại chứ ký (RMS Type)" prop="rms_type">
                <el-select v-model="form.rms_type" placeholder="Chọn loại RMS" class="w-100">
                  <el-option label="PIN" value="PIN"></el-option>
                  <el-option label="OTP" value="OTP"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Gói dịch vụ" prop="package_code">
                <el-select v-model="form.package_code" placeholder="Chọn gói" class="w-100">
                  <el-option v-for="pkg in packages" :key="pkg.code"
                    :label="pkg.name + (pkg.description ? ' - ' + pkg.description : '')" :value="pkg.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="Tệp đính kèm" prop="attachment">
            <el-upload ref="upload" :auto-upload="false" action="" :on-change="handleFileChange" :limit="1"
              accept=".pdf,.jpg,.png,.doc,.docx">
              <el-button slot="trigger" type="primary">Chọn file</el-button>
              <div class="el-upload__tip" slot="tip">Chỉ hỗ trợ file PDF, JPG, PNG, DOC, DOCX (Max 10MB)
              </div>
            </el-upload>
            <div v-if="form.attachment" class="mt-2 text-sm text-gray-600">
              Tệp đã chọn: {{ form.attachment.name }}
            </div>
          </el-form-item>

          <!-- Validation Errors -->
          <div v-if="apiError" class="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
            <div class="text-sm text-red-700" v-html="apiError"></div>
          </div>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Hủy</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="isLoading">Đăng ký</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SignatureRequest from '@/api/request/SignatureRequest'

export default {
  name: 'ModalRegisterIntrustCACert',
  props: {
    certType: {
      type: String,
      default: 'personal' // 'personal' or 'organization'
    }
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      isLoadingData: false,
      apiError: '',
      packages: [],
      provinces: [],
      form: {
        name_KH: '',
        personal_position_customer: '',
        telephoneNumber_KH: '',
        email_KH: '',
        org_tax_number: '',
        buyer_CRM: 'HODO',
        type_CTS_code: 'CN',
        type_paper_code: 'CCCD',
        individual_identifier_code: '',
        province_code: '',
        province_name: '',
        personal_name: '',
        address: '',
        mobile_legal: '',
        email_legal: '',
        rms_type: 'PIN',
        method_verification_code: 'HS_DIENTU',
        package_code: 'P12M00',
        representative_position_personal: '',
        department: '',
        organization_type_paper_code: 'MST',
        is_cert_by_number_signatures: '0',
        organization_name: '',
        request_type_code: 'CAP_MOI',
        attachment: null
      },
      rules: {
        name_KH: [{ required: true, message: 'Vui lòng nhập họ tên', trigger: 'blur' }],
        telephoneNumber_KH: [{ required: true, message: 'Vui lòng nhập số điện thoại', trigger: 'blur' }],
        email_KH: [{ required: true, type: 'email', message: 'Vui lòng nhập email hợp lệ', trigger: 'blur' }],
        personal_position_customer: [{ required: true, message: 'Vui lòng nhập vị trí cá nhân', trigger: 'blur' }],
        province_name: [{ required: true, message: 'Vui lòng nhập tỉnh/thành phố', trigger: 'blur' }],
        province_code: [{ required: true, message: 'Vui lòng nhập mã tỉnh/thành phố', trigger: 'blur' }],
        address: [{ required: true, message: 'Vui lòng nhập địa chỉ', trigger: 'blur' }],
        type_paper_code: [{ required: true, message: 'Vui lòng chọn loại giấy tờ', trigger: 'change' }],
        individual_identifier_code: [{ required: true, message: 'Vui lòng nhập số giấy tờ nhận dạng', trigger: 'blur' }],
        personal_name: [{ required: true, message: 'Vui lòng nhập tên người liên hệ', trigger: 'blur' }],
        mobile_legal: [{ required: true, message: 'Vui lòng nhập số điện thoại liên hệ', trigger: 'blur' }],
        email_legal: [{ required: true, type: 'email', message: 'Vui lòng nhập email liên hệ hợp lệ', trigger: 'blur' }],
        rms_type: [{ required: true, message: 'Vui lòng chọn loại RMS', trigger: 'change' }],
        package_code: [{ required: true, message: 'Vui lòng chọn gói dịch vụ', trigger: 'change' }]
      }
    }
  },
  async mounted () {
    await this.loadInitialData()
  },
  methods: {
    async loadInitialData () {
      this.isLoadingData = true
      try {
        const request = new SignatureRequest()
        const [packagesRes, provincesRes] = await Promise.all([
          request.getIntrustCAPackages(),
          request.getIntrustCAProvinces()
        ])

        if (packagesRes.status === 200 && packagesRes.data.success) {
          this.packages = packagesRes.data.data || []
        }

        if (provincesRes.status === 200 && provincesRes.data.success) {
          this.provinces = provincesRes.data.data || []
        }
      } catch (error) {
        console.error('Error loading initial data:', error)
      } finally {
        this.isLoadingData = false
      }
    },
    handleOpen (existingData = null) {
      this.isOpen = true
      if (existingData) {
        // Populate form with existing data for editing
        this.$nextTick(() => {
          Object.keys(existingData).forEach(key => {
            if (this.form.hasOwnProperty(key)) {
              this.form[key] = existingData[key]
            }
          })
        })
      } else {
        this.resetForm()
      }
    },
    handleClose () {
      this.isOpen = false
      this.resetForm()
    },
    resetForm () {
      if (this.$refs.registerForm) this.$refs.registerForm.resetFields()
      this.apiError = ''
      this.form.attachment = null
      this.form.province_name = ''
    },
    handleProvinceChange (code) {
      const selected = this.provinces.find(p => p.code === code)
      if (selected) {
        this.form.province_name = selected.name
      }
    },
    handleFileChange (file) {
      if (file.size > 10 * 1024 * 1024) {
        this.$message.warning('Kích thước file không được vượt quá 10MB')
        this.$refs.upload.clearFiles()
        return
      }
      this.form.attachment = file.raw
    },
    useApplicantAsContact () {
      this.form.personal_name = this.form.name_KH
      this.form.mobile_legal = this.form.telephoneNumber_KH
      this.form.email_legal = this.form.email_KH
    },
    async handleSubmit () {
      try {
        const valid = await this.$refs.registerForm.validate()
        if (!valid) return

        this.isLoading = true
        this.apiError = ''

        // Build FormData for multipart/form-data
        const formData = new FormData()
        Object.keys(this.form).forEach(key => {
          if (key !== 'attachment') {
            formData.append(key, this.form[key])
          }
        })
        if (this.form.attachment) {
          formData.append('attachment', this.form.attachment)
        }

        const request = new SignatureRequest()
        const response = await request.createIntrustCACert(formData)
        console.log('🚀 ~ response:', response.data)

        if (response.status === 201 && response.data.success) {
          this.$message({ type: 'success', message: 'Đăng ký chữ ký số thành công' })
          this.$emit('onSuccess', response.data.data)
          this.handleClose()
        } else {
          const message = response.data.message || 'Đăng ký thất bại'
          this.apiError = message
          this.$message({ type: 'error', message })
        }
      } catch (error) {
        console.error('Register error:', error)
        const message = error.response?.data?.message || error.response?.data?.error || error.message || 'Đăng ký thất bại'
        this.apiError = message
        this.$message({ type: 'error', message })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
::v-deep .el-dialog__header {
  padding: 20px 20px 10px;
  border-bottom: 1px solid #f0f0f0;
}

::v-deep .el-dialog__body {
  padding: 30px 20px;
  max-height: 60vh;
  overflow-y: auto;
}

::v-deep .el-dialog__footer {
  padding: 10px 20px 20px;
  border-top: 1px solid #f0f0f0;
}

::v-deep .el-form-item__label {
  font-weight: 600;
  color: #333;
}

::v-deep .el-divider {
  margin: 20px 0;
}

::v-deep .el-form-item {
  margin-bottom: 20px;
}

::v-deep .el-form-item__label {
  line-height: 14px !important;
}

::v-deep .el-textarea textarea {
  height: 40px !important;
}
</style>
